import useDataProvider from "./useDataProvider";
import buildDataProvider from "./buildDataProvider";
export * from "./types";

export { useDataProvider, buildDataProvider };

export default buildDataProvider;
